import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './store/shared/context/AuthContext';
import { CartProvider } from './store/shared/context/CartContext';
import { WishlistProvider } from './store/shared/context/WishlistContext';
import { StatusProvider } from './store/status/StatusContext';
import PeacockBurst from './store/intro/PeacockBurst';
import FixedSocialLinks from './store/shared/components/FixedSocialLinks';
import SiteFavicon from './store/shared/components/SiteFavicon';
import HomePage from './store/home/HomePage';
import ProductsPage from './store/products/ProductsPage';
import ProductDetailPage from './store/product-detail/ProductDetailPage';
import CartPage from './store/cart/CartPage';
import WishlistPage from './store/wishlist/WishlistPage';
import AccountPage from './store/account/AccountPage';
import AboutPage from './store/pages/AboutPage';
import FaqsPage from './store/pages/FaqsPage';
import PrivacyPage from './store/pages/PrivacyPage';
import TermsPage from './store/pages/TermsPage';
import NotFoundPage from './store/pages/NotFoundPage';
import { AdminLayout } from './admin/shell/AdminShell';
import AdminLogin from './admin/login/AdminLogin';
import AdminDashboard from './admin/dashboard/AdminDashboard';
import './index.css';

export default function App() {
  return (
    <BrowserRouter>
      <StatusProvider>
        <AuthProvider>
          <CartProvider>
            <WishlistProvider>
              <PeacockBurst />
              <SiteFavicon />
              <FixedSocialLinks />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/products/:id" element={<ProductDetailPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/wishlist" element={<WishlistPage />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/faqs" element={<FaqsPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminLayout />}>
                  <Route index element={<AdminDashboard />} />
                </Route>
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </WishlistProvider>
          </CartProvider>
        </AuthProvider>
      </StatusProvider>
    </BrowserRouter>
  );
}
